import moment from "moment";
import queryString from "query-string";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { formatAmount } from "../../../../../../utils/commonUtil";
import { getAccountData, getPrimaryAccount, isGeminiUser } from "../../../../../../utils/sessionUtil";
import FlowFooter from "../../../RecommendGrant/Component/FlowFooter/FlowFooter";
import PermissionToPublish from "../../../RecommendGrant/Component/ViewEditSchedules/Components/PermissionToPublish";
import CharityDetailSummary from "../../Components/StepOneSummary/CharityDetailSummary";
import PurposeRecognition from "../../Components/StepOneSummary/PurposeSummary";
import Step2Summary from "../../../RecommendGrant/Component/ViewEditSchedules/Components/Step2Summary";
import { SectionMediumDivider } from "../../../RecommendGrant/style";
import { disclaimerCheckbox, editReset, editSet, saveGrantAgreement, newAgreement } from "../../actions";
import PreviewLetters from "../../Components/ReviewAndSubmit/Components/PreviewLetter/PreviewLetters";
import DisclaimerLayout from "../../../RecommendGrant/Component/ViewEditSchedules/Components/DisclaimerLayout";
import { GrantAgreementContent, GrantAgreementSectionLastHeading, SectionDivider, DisclaimerContainer } from "../../styles";
import { fetchAccountAdvisors } from "./../../../../../../actions/globalActions";
import Step3Summary from "./Step3Summary";
import { ContentProvider, Types, ContentMessage } from "../../../../../../CommonComponents/ContentMessages";
import { checkCSRBusinessFunction } from "../../../../../../CSR/utils/CommonUtils";
import { BUSINESS_FUNCTION } from "../../../../../../CSR/utils/csrBusinessFunctionMapper";
import { editAndReviewDerivedStates } from '../../Selectors/EditAndReviewSelectors';

export class EditAndReviewGrant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disclaimerCheckbox: null,
      grantSuccess: false,
    };
    this.disclaimerCheckboxField = this.disclaimerCheckboxField.bind(this);
    this.popUpContents = {
      disclaimer:
        "To successfully submit this grant recommendation, you must click the checkbox at the bottom of the screen to certify the information on this page is accurate"
    };
  }

  componentDidUpdate(nextProps) {
    if (nextProps.agreement !== this.props.agreement) {
      let fetchgrantId = this.props.agreement.split(":");
      const location = {
        pathname: "/grants/grant-agreement/confirm",
        search: queryString.stringify({
          grantAgreementId: fetchgrantId[1]
        })
      };
      this.props.history.push(location);
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.editReset();
    this.props.fetchAdvisors({ accountId: getPrimaryAccount().userId });
  }

  onEditClick = path => {
    this.props.editSet(true);
    this.props.history.push(path);
  };

  checkAccess = () => {
    return isGeminiUser() ? this.checkCsrAccess('DONOR_PORTAL_RECOMMEND_GRANT_FULL_ACCESS') : true
  }

  // Check the feature is avalilable by the particular csr user
  checkCsrAccess = businessFunction => {
    return !checkCSRBusinessFunction(
      BUSINESS_FUNCTION[businessFunction],
      this.props.csrBusinessFunction
    )
  }

  getPaymentMethodFormatted(payment) {
    const output = payment.map(each => {
      let updatedRequirementDueDateFormat = null;
      let updatedPaymentDateFormat = null;
      if (each.grantRequirementDueDate) {
        updatedRequirementDueDateFormat = this.getDateFormatted(
          each.grantRequirementDueDate
        );
      }
      if (each.intendedPaymentDate) {
        updatedPaymentDateFormat = this.getDateFormatted(
          each.intendedPaymentDate
        );
      }
      return {
        ...each,
        intendedPaymentDate: updatedPaymentDateFormat,
        grantRequirementDueDate: updatedRequirementDueDateFormat,
        isContingent: each.isContingent ? "Y" : "N"
      };
    });
    return output;
  }

  getDateFormatted(data) {
    return moment(data).format("YYYY-MM-DD");
  }

  changeToFloat(data, decimalPlace) {
    return parseFloat(data).toFixed(decimalPlace);
  }

  typeChange(data) {
    const output = data.map(each => {
      let {
        amountAllocated,
        amountAllocatedWeighted,
        percentageAllocated
      } = each;
      return {
        ...each,
        amountAllocated: !amountAllocated
          ? null
          : this.changeToFloat(each.amountAllocated, 2),
        amountAllocatedWeighted: !amountAllocatedWeighted
          ? null
          : this.changeToFloat(each.amountAllocatedWeighted, 2),
        percentageAllocated: !percentageAllocated
          ? null
          : this.changeToFloat(each.percentageAllocated, 2)
      };
    });
    return output;
  }

  getThirdPartyData(id, type) {
    const { accountName, thirdParty } = this.props.grantRecognition;
    if (id !== "40") {
      if (id === "20" && type === "thankIndividualName") {
        return thirdParty;
      }
      if ((id === "10" || id === "30" || id === "20") && type === "accountName") {
        return accountName;
      }
    }
    return null;
  }

  disclaimerCheckboxField = event => {
    this.setState({ disclaimerCheckbox: event.target.checked, errorPopup: false });
  };

  handleSubmit = () => {
        if (this.state.disclaimerCheckbox) {
      const {
        payment,
        selectedCharityEin,
        selectedCharityId,
        grantPurpose,
        fundPools,
        granteeOrgFirstName,
        granteeOrgLastName,
        granteeOrgEmailAddr,
        granteeOrgPhoneNumber,
        grantRecognition,
        grantAgreementAmount,
        grantAllocationSelect,
        permissionToPublish
      } = this.props;
      
      const {
        inHonorOfName,
        inMemoryOfName,
        notifyFirstName,
        notifyLastName,
        includeAdvisorInfo
      } = grantRecognition;
      this.setState({ grantSuccess: true });

      const userData = getAccountData();
      const { partyId } = userData;
      const agreementSubmitData = {
        partyId,
        startDate:
          payment.length &&
          this.getDateFormatted(payment[0].intendedPaymentDate),
        endDate: this.maxDate('YYYY-MM-DD'),
        granteeOrg: {
          granteeOrgId: selectedCharityId,
          ein: selectedCharityEin
        },
        purpose: {
          ...grantPurpose,
          publishName: !permissionToPublish,
          description:
            grantPurpose.description === "Unrestricted Gift"
              ? "Unrestricted gift"
              : grantPurpose.description,
              otherIndDoNotIncAcctAdv: includeAdvisorInfo ? "off" : "on",
        },
        percentAllocFlag: grantAllocationSelect === "byPercentage",
        amntAllocFlag: grantAllocationSelect === "byDollars",
        weightedAllocFlag: grantAllocationSelect === "weightedAllocations",
        fundPoolChecked: [],
        allShareallPool: "",
        fundPool: this.typeChange(fundPools),
        granteeOrgCntFirstName: granteeOrgFirstName,
        granteeOrgCntLastName: granteeOrgLastName,
        granteeOrgCntPhoneNumber: granteeOrgPhoneNumber,
        granteeOrgCntEmailAddr: granteeOrgEmailAddr,
        grantAgreementTotalAmount: this.changeToFloat(grantAgreementAmount, 2),
        grantRecognition: {
          grantRecognition: grantRecognition.grantRecognition,
          thankIndividualName: this.getThirdPartyData(
            grantRecognition.grantRecognition,
            "thankIndividualName"
          ),
          accountName: getPrimaryAccount().accountName,
          notifyAdditionalNames: null,
          notifyFirstName,
          notifyLastName,
          inMemoryOfName,
          inHonorOfName,
          grantNotes: "",
          type: null
        },
        paymentMappings:
          payment.length && this.getPaymentMethodFormatted(payment)
      };
      this.props.saveGrantAgreement({
        method: "PUT",
        url: `/donor-portal/api/grantAgreement/${
          getPrimaryAccount().userId
          }/saveGrantAgreement`,
        data: agreementSubmitData,
        successFn: () => {
          this.setState({ grantSuccess: false });
        }
      });
    } else this.setState({ errorPopup: true });
  };

  dollarSelection = pool => {
    if (this.props.grantAllocationSelect === "weightedAllocations")
      return pool.amountAllocatedWeighted;
    else if (this.props.grantAllocationSelect === "byDollars")
      return pool.weightedPercenatgePerPool;
    else return pool.amountAllocated;
  };

  paymentStructure = () =>
    this.props.payment.length &&
    this.props.payment.map(item => ({
      paymentAmount: item.grantAmountStr,
      isPaymentContingent: item.isContingent,
      intendedPaymentDate: item.intendedPaymentDate,
      requirementType: item.requirementType,
      isReportingRequired: item.reportRequirement,
      requirementDueDate: item.grantRequirementDueDate
    }));

  publisher = () => {
    if (
      this.props.grantRecognition.grantRecognition === "30" ||
      this.props.permissionToPublish
    )
      return false;
    return true;
  };

  charityRender = () => ({
    charityAddress: this.props.selectedCharityAddress,
    charityEin: this.props.selectedCharityEin,
    charityName: this.props.selectedCharityName,
    title: "Charity Information"
  });

  contactDetailRender = () => ({
    contactName: this.props.granteeOrgFirstName,
    contactLastName: this.props.granteeOrgLastName,
    contactPhoneNumber: this.props.granteeOrgPhoneNumber,
    contactEmail: this.props.granteeOrgEmailAddr
  })

  purposeRender = () => {
    const honorName = this.props.grantRecognition.inHonorOfName ? `In honor of ${this.props.grantRecognition.inHonorOfName}` : '';
    const memoryName = this.props.grantRecognition.inMemoryOfName ? `In memory of ${this.props.grantRecognition.inMemoryOfName}` : '';
    return {
      accountName: this.props.data.accountName,
      additionalComments: this.props.grantPurpose.additionalComments,
      advisors: this.props.advisors,
      grantRecognition: this.props.grantRecognition.grantRecognition,
      inHonorOfName: honorName,
      inMemoryOfName: memoryName,
      includeAdvisorInfo: this.props.grantRecognition.includeAdvisorInfo,
      notifyName: null,
      purposeName: this.props.grantPurpose.description,
      thirdParty: this.props.grantRecognition.thirdParty,
      title: "Grant purpose & recognition"
    }
  };

  maxDate = (format) => {
    const allDates = [];
    this.props.payment.forEach(pay => {
      if(pay.intendedPaymentDate) allDates.push(moment(pay.intendedPaymentDate));
      if(pay.grantRequirementDueDate) allDates.push(moment(pay.grantRequirementDueDate));
    });
    return moment.max(allDates).format(format)
  }
  
  amountAllocationRender = () => {
    const { fundPools = [], grantAgreementAmount, payment = [], grantAllocationSelect } = this.props;

    const poolPercentage = pool => {
      if (pool.percentageAllocated) return pool.percentageAllocated;
      else return (100 / (parseFloat(grantAgreementAmount) / parseFloat(pool.weightedPercenatgePerPool))).toFixed(2);
    };

    const amountString =
      payment.length &&
      `${payment.length} for a total of ${formatAmount(grantAgreementAmount)}`;

    let allocations =
      fundPools &&
      fundPools.reduce((generated, pool, index) => {
        let temPool = {};
        temPool.name = pool.position.pool.name;
        temPool.grantAmount = this.dollarSelection(pool);
        temPool.grantPercentage = poolPercentage(pool);
        temPool.id = ++index;
        generated.push(temPool);
        return generated;
      }, []);
    return {
      title: "Recommended amount & allocation",
      amountString,
      grantAgreement: true,
      recurring: true,
      grantAgreementAmount: grantAgreementAmount,
      startDate: payment.length && payment[0].intendedPaymentDate,
      endDate: this.maxDate('MM/DD/YYYY'),
      allocationType: grantAllocationSelect,
      allocations
    };
  };

  handleExit = () => {
    this.props.newAgreement();
    this.props.history.push('/');
  };

  render() {
    const { history } = this.props;
    const { errorPopup, grantSuccess } = this.state;

    const charityProps = {
      ...this.charityRender(),
      edit: true,
      handleEdit: () => this.onEditClick("/grants/grant-agreement/charity-purpose")
    };

    const contactProps = {
      ...this.contactDetailRender(),
    };

    const prProps = {
      ...this.purposeRender(),
      edit: true,
      handleEdit: () => this.onEditClick("/grants/grant-agreement/charity-purpose")
    };

    return (
      <>
        <div>
          <GrantAgreementSectionLastHeading
            marginBottom="15px"
            mobmt="10px"
            mobmb="10px"
          >
            Review your grant
        </GrantAgreementSectionLastHeading>
          <GrantAgreementContent mobmb="40px">
            Review your grant recommendation information below, edit it if
            necessary, before submitting.
        </GrantAgreementContent>
          <SectionMediumDivider />
          <CharityDetailSummary charityInfo={charityProps} contactInfo={contactProps} codeValueMappingData={this.props.codeValueMappingData} />
          <SectionMediumDivider />
          <PurposeRecognition purposeRecognition={prProps}/>
          <SectionMediumDivider />
          <PermissionToPublish
            publish={this.publisher()}
            edit={true}
            handleEdit={() => this.onEditClick("/grants/grant-agreement/charity-purpose")}
            isGaw={false}
          />
          <SectionMediumDivider />
          <Step2Summary
            {...this.amountAllocationRender()}
            edit={true}
            handleEdit={() => this.onEditClick("/grants/grant-agreement/allocation-schedule")}
          />
          <SectionMediumDivider />
          <div>
            <Step3Summary
              title="Grant Agreement Payments"
              payments={this.paymentStructure()}
              edit
              handleEdit={() => this.onEditClick("/grants/grant-agreement/allocation-schedule")}
            />
          </div>
          <SectionMediumDivider />
          <PreviewLetters
            id={"multipage"}
            advisors={this.props.advisors}
            {...this.props}
          />
          <ContentProvider types={[Types.PAGE_DISCLAIMERS]} pages={['Grant Agreement']}>
            <DisclaimerContainer>
              <DisclaimerLayout
                value={this.state.disclaimerCheckbox}
                handleChange={this.disclaimerCheckboxField}
                showError={errorPopup}
                isGaw={true}
                content={
                  <ContentMessage
                    page="Grant Agreement"
                    type={Types.PAGE_DISCLAIMERS}
                    property="field_disclaimer_content"
                    html
                  />
                }
              />
            </DisclaimerContainer>
          </ContentProvider>

          <SectionDivider />
          <FlowFooter
            spin={grantSuccess}
            edit={false}
            enableUpdate={false}
            enablePrimary={this.checkAccess()} //return false for disabed
            primaryCtaLabel="Submit"
            enableCancelPopUp={false}
            page={"Grant Agreement"}
            keyProperty={"Exit Grant Agreement"}
            handleSecondaryCta={() => history.push("/grants/grant-agreement/allocation-schedule")}
            handleExitCta={this.handleExit}
            handlePrimaryCta={this.handleSubmit}
          />
        </div>
      </>
    );
  }
}

EditAndReviewGrant.propTypes = {
  advisors: PropTypes.array,
  agreement: PropTypes.any,
  codeValueMappingData: PropTypes.object,
  csrBusinessFunction: PropTypes.any,
  data: PropTypes.object,
  editReset: PropTypes.func,
  editSet: PropTypes.func,
  fetchAdvisors: PropTypes.func,
  fundPools: PropTypes.array,
  grantAgreementAmount: PropTypes.string,
  grantAllocationSelect: PropTypes.string,
  grantPurpose: PropTypes.object,
  grantRecognition: PropTypes.object,
  granteeOrgEmailAddr: PropTypes.string,
  granteeOrgFirstName: PropTypes.string,
  granteeOrgLastName: PropTypes.string,
  granteeOrgPhoneNumber: PropTypes.string,
  newAgreement: PropTypes.func,
  payment: PropTypes.array,
  permissionToPublish: PropTypes.any,
  saveGrantAgreement: PropTypes.func,
  selectedCharityAddress: PropTypes.object,
  selectedCharityEin: PropTypes.string,
  selectedCharityId: PropTypes.number,
  selectedCharityName: PropTypes.string
}

const mapStateToProps = state => ({
  ...editAndReviewDerivedStates(state.toJS()),
});

const mapDispatchToProps = dispatch => ({
  checkBoxChange: val => dispatch(disclaimerCheckbox(val)),
  fetchAdvisors: payload => dispatch(fetchAccountAdvisors(payload)),
  saveGrantAgreement: (data, successFn) => dispatch(saveGrantAgreement(data, successFn)),
  editSet: clicked => dispatch(editSet(clicked)),
  editReset: data => dispatch(editReset(data)),
  newAgreement: data => dispatch(newAgreement(data))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EditAndReviewGrant) 
);
